import { render, staticRenderFns } from "./common-table.vue?vue&type=template&id=009dfe16&scoped=true&"
import script from "./common-table.vue?vue&type=script&lang=js&"
export * from "./common-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009dfe16",
  null
  
)

export default component.exports